<template>
<div id="chart">
  <b-container class="py-5">
    <div class="d-flex justify-content-center">
      <div class="border-top border-bottom border-dark border-2px py-3">
        <h3 class="overpass text-center h1 mb-0">サイズ・仕様</h3>
      </div>
    </div>
    <b-row class="justify-content-center">
      <b-col cols="12" md="10" lg="8">
        <dl class="row h5 align-items-md-center mt-5 tracking-2">
          <dt class="col-3 col-md-3 col-lg-2 mb-2 text-md-right">
            サイズ
          </dt>
          <dd class="d-none d-md-block col-md-3 col-lg-4 col-xl-3">
            <hr class="border-dashed border-dark">
          </dd>
          <dd class="col-9 col-md-6 col-xl-7 mb-4 mb-md-3">
            メンズXS / S / M / L / XL / 2XL
          </dd>
          <dt class="col-3 col-md-3 col-lg-2 mb-2 text-md-right">
            <span class="mr-3">素</span>材
          </dt>
          <dd class="d-none d-md-block col-md-3 col-lg-4 col-xl-3">
            <hr class="border-dashed border-dark">
          </dd>
          <dd class="col-9 col-md-6 col-xl-7 mb-4 mb-md-3">
            ポリエステル100%
          </dd>
          <dt class="col-3 col-md-3 col-lg-2 mb-2 text-md-right">
            生産国
          </dt>
          <dd class="d-none d-md-block col-md-3 col-lg-4 col-xl-3">
            <hr class="border-dashed border-dark">
          </dd>
          <dd class="col-9 col-md-6 col-xl-7">
            日本
          </dd>
        </dl>
        <h5 class="mt-5 mb-3 h4">【サイズチャート】</h5>
        <div class="table-responsive">
          <table class="table table-bordered text-center">
            <tbody>
              <tr>
                <td style="width: 70px;"></td>
                <td>着丈</td>
                <td class="px-0">身幅<small>(胸囲)★</small></td>
                <td>肩幅</td>
                <td>袖丈</td>
                <td>襟周り</td>
              </tr>
              <tr class="overpass">
                <td>XS</td>
                <td>65<small>cm</small></td>
                <td>102<small>cm</small></td>
                <td>43<small>cm</small></td>
                <td>57.5<small>cm</small></td>
                <td>39.5<small>cm</small></td>
              </tr>
              <tr class="overpass">
                <td>S</td>
                <td>66.5<small>cm</small></td>
                <td>105<small>cm</small></td>
                <td>44<small>cm</small></td>
                <td>59<small>cm</small></td>
                <td>40.5<small>cm</small></td>
              </tr>
              <tr class="overpass">
                <td>M</td>
                <td>68<small>cm</small></td>
                <td>108<small>cm</small></td>
                <td>45<small>cm</small></td>
                <td>60.5<small>cm</small></td>
                <td>41.5<small>cm</small></td>
              </tr>
              <tr class="overpass">
                <td>L</td>
                <td>69.5<small>cm</small></td>
                <td>111<small>cm</small></td>
                <td>46<small>cm</small></td>
                <td>62<small>cm</small></td>
                <td>42.5<small>cm</small></td>
              </tr>
              <tr class="overpass">
                <td>XL</td>
                <td>71<small>cm</small></td>
                <td>114<small>cm</small></td>
                <td>47<small>cm</small></td>
                <td>63.5<small>cm</small></td>
                <td>43.5<small>cm</small></td>
              </tr>
              <tr class="overpass">
                <td>2XL</td>
                <td>71.5<small>cm</small></td>
                <td>117<small>cm</small></td>
                <td>48<small>cm</small></td>
                <td>64<small>cm</small></td>
                <td>44.5<small>cm</small></td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          ※サイズは若干の誤差が生じる場合があります。<br>
          ★脇下をぐるりと一周した長さです。
        </p>
        <h5 class="mt-5 mb-3 h4">【洗濯表示】</h5>
        <p><img class="img-fluid" src="@/assets/images/laundry-icons.svg"></p>
        <h5 class="mt-5 mb-3 h4">【ご注意】</h5>
        <ul>
          <li>蛍光増白剤入り洗剤のご使用はお避けください。</li>
          <li>タンブラーの乾燥はお避けください。</li>
          <li>洗濯時、ネットを使用してください。</li>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>

export default {
  name: 'Chart',
  components: {
  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
#chart {
  background-color: #eaf6fd;
}
table {
  table-layout: auto;
  @media screen and (min-width: 756px){
    table-layout: fixed;    
  }
  tr:not(:first-child) {
    font-size: 1.25rem;
  }
}
</style>
